// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1DXzZ","resendInfoText":"OnGoingPaymentBox_resendInfoText__fAzjX"};